<div class="flex flex-row">
  <span [className]="customClassForMessage">{{message}}</span>
  <pin-three-dots customClass="{{customClassForDots}}"></pin-three-dots>
</div>
